import { Formik, FormikHelpers } from 'formik'
import { Button, InputField, Modal } from '../../../../components'
import { EditLeaveTypeIProps } from '../../../leavepolicy/leavetypes/types'
import { updateLeaveTypes } from '../../leavetypes/api/index'
import { useAppDispatch } from '../../../../redux/hook'
import { SHOW_NOTIFICATION } from '../../../../redux/slices/showNotificationSlice'
import { HIDE_LOADER, SHOW_LOADER } from '../../../../redux/slices/LoaderSlice'
import { updateLeaveType } from '../../leavetypes/slice/index'

interface PolicyFormValues {
    leaveTypeName: string
}

const EditLeaveType = ({
    show,
    onClose,
    editLeaveTypeDetails,
}: EditLeaveTypeIProps) => {
    const dispatch = useAppDispatch()

    return (
        <Modal
            show={show}
            handleClose={() => onClose(false)}
            title="Edit Leave Type"
            body={
                <Formik
                    initialValues={{
                        leaveTypeName: editLeaveTypeDetails?.leaveTypeName
                            ? editLeaveTypeDetails?.leaveTypeName
                            : '',
                    }}
                    onSubmit={async (
                        values,
                        actions: FormikHelpers<PolicyFormValues>
                    ) => {
                        try {
                            dispatch(SHOW_LOADER())
                            const response = await updateLeaveTypes({
                                leaveTypeName: values.leaveTypeName,
                                leaveTypeId:
                                    editLeaveTypeDetails?.leaveTypeId || '',
                            })
                            const updatedId = response.data
                            const updatedLeaveType = {
                                id: updatedId,
                                title: values.leaveTypeName,
                                numberOfLeaves: 0,
                                isCarryOver: false,
                            }
                            dispatch(updateLeaveType(updatedLeaveType))
                            if (response.status === 200) {
                                dispatch(
                                    SHOW_NOTIFICATION({
                                        message:
                                            'Leave type updated successfully',
                                        type: 'success',
                                    })
                                )
                            }
                            actions.setSubmitting(false)
                            onClose(false)
                        } catch (error) {
                            dispatch(
                                SHOW_NOTIFICATION({
                                    message: 'Something went wrong',
                                    type: 'error',
                                })
                            )
                            console.error('Error creating leave type:', error)
                        } finally {
                            dispatch(HIDE_LOADER())
                            actions.setSubmitting(false)
                            onClose(false)
                        }
                    }}
                >
                    {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isSubmitting,
                    }) => (
                        <form onSubmit={handleSubmit}>
                            <div className="bg-green-color">
                                <InputField
                                    type="text"
                                    lable={''}
                                    name="leaveTypeName"
                                    value={values.leaveTypeName}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={errors.leaveTypeName}
                                    touched={touched.leaveTypeName}
                                    placeholder={
                                        editLeaveTypeDetails?.leaveTypeName
                                    }
                                />
                            </div>
                            <div className="footer-block">
                                <Button disabled={isSubmitting} type="submit">
                                    SAVE
                                </Button>
                                <Button
                                    disabled={isSubmitting}
                                    type="button"
                                    variant="outline-success"
                                    onClick={() => onClose(false)}
                                >
                                    CANCEL
                                </Button>
                            </div>
                        </form>
                    )}
                </Formik>
            }
            onSuccess={() => {
                onClose(false)
            }}
        />
    )
}
export default EditLeaveType
